export const SLIDE_SWITCHING_DELAY = 5000;
export const SLIDE_APPEARING_TIME = 200;
